var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group row",class:[
    _vm.lmButtonRootWrapperClass,
    {'avoid-pointer-events': this.isProcessing}
    ],attrs:{"id":"lm-button-root-wrapper"}},[_c('div',{class:[
        _vm.lmButtonWrapperClass,
        {'col-sm-10':!_vm.lmButtonWrapperClass}
      ],attrs:{"id":"lm-button-wrapper"}},[_c('button',{ref:"lmButton",staticClass:"btn d-flex justify-content-center",class:[
        _vm.buttonClass,
        {'btn-info': !_vm.buttonClass && !_vm.disabled},
        {disabled: _vm.disabled}
      ],style:({width: _vm.buttonWidth, height: _vm.buttonHeight}),attrs:{"id":"lm-button","type":_vm.type,"disabled":_vm.disabled || _vm.isProcessing}},[(_vm.isProcessing)?_c('LmSpinnerBorder'):_vm._e(),_vm._v("\n        "+_vm._s(_vm.text)+"\n      ")],1)]),(_vm.showTooltip)?_c('b-tooltip',{attrs:{"target":"lm-button-wrapper","placement":"top"}},[_vm._v("\n    "+_vm._s(_vm.tooltip.value)+"\n  ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }